export default __webpack_public_path__ + "static/media/2.2ea5ff8a.png";